import { POST } from "../../APiHelper/API";

export const undoDeleteTeamAPI = (id, onSuccess, onError) => {
    const data = {
        id: id
    }
    POST(`/api/v1/leagues/team/undo_remove`, data, onSuccess, onError)
}